import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { effectiveRoleOf, useAuthStore } from '../../stores/authStore';
import type { Role } from '../../types';

interface Props {
  allow: ReadonlyArray<Role>;
  children: ReactNode;
  fallback?: ReactNode;
}

// Richtet sich nach der EFFEKTIVEN Rolle (Admin-Vorschau „Ansicht als …"),
// damit sich Routen/Elemente in der Vorschau genauso verhalten wie für die
// echte Rolle — z. B. /admin wird für einen als „Servicekraft" vorschauenden
// Admin ausgeblendet, obwohl die echten Rechte weiterhin Admin sind.
export function RoleGuard({ allow, children, fallback }: Props) {
  const { role, viewAsRole, isInitialized } = useAuthStore();
  if (!isInitialized) return null;
  const effective = effectiveRoleOf({ role, viewAsRole });
  if (!effective || !allow.includes(effective)) {
    return fallback !== undefined ? <>{fallback}</> : <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
